module.exports = __webpack_public_path__ + "static/media/ProximaNova-RegularItalic.c8708c7a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-RegularItalic.otf
// module id = 1633
// module chunks = 49